<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';
import FormSidebarBtn from "../../common/form/FormSidebarBtn.vue";

const props = defineProps({
    formId: {
        type: String,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---
const order = ref({});

// --- Computed ---
const tableName = computed(() => store.state[props.formId]?.tableName);
const id = computed(() => store.state[props.formId]?.id);

const show = computed(() => tableName.value === 'm_basket_orders');

const isDisabled = computed(() => order.value.orderStatus !== 'Completed');

// --- Watcher (Replaces asyncComputed) ---
watch(() => [show.value, id.value], async ([shouldShow, currentId]) => {
    if (shouldShow && currentId) {
        order.value = await store.dispatch('itemData/get', {
            tableName: 'm_basket_orders',
            id: currentId
        });
    } else {
        order.value = {};
    }
}, { immediate: true });

// --- Methods ---
const onClick = () => {
    if (isDisabled.value) {
        alert("The order's status must be 'Completed'.");
        return;
    }

    // Toggle logic: If truthy, set to 0. If falsy, set to current Unix timestamp.
    const newValue = order.value.requestAReview
        ? 0
        : Math.floor(Date.now() / 1000);

    // Update local state immediately for UI snappiness
    order.value.requestAReview = newValue;

    const orderId = order.value.id;

    store.dispatch('request/patch', {
        url: 'api/component/m_basket_orders/' + orderId,
        postData: {
            requestAReview: newValue
        }
    }).then(() => {
        // Sync the global itemData cache
        store.dispatch('itemData/set', {
            tableName: 'm_basket_orders',
            id: orderId,
            property: 'requestAReview',
            value: newValue
        });
    });
};
</script>

<template>
    <FormSidebarBtn v-if="show" :disabled="isDisabled" @click.prevent.stop.native="onClick">
        <span
            :class="{ 'bi-square': !order.requestAReview, 'bi-check-square': order.requestAReview }"
            class="me-2"
        />
        Request a review
    </FormSidebarBtn>
</template>